import { render, staticRenderFns } from "./familiarProblem.vue?vue&type=template&id=44ae1f16"
import script from "./familiarProblem.vue?vue&type=script&lang=js"
export * from "./familiarProblem.vue?vue&type=script&lang=js"
import style0 from "./familiarProblem.vue?vue&type=style&index=0&id=44ae1f16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports